import Axios from "axios";

var date = new Date();
var timezone = date.getTimezoneOffset();


const appConfig = Axios.create({
  baseURL: `https://${process.env.REACT_APP_DEFAULT_API_URL}`,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add a request interceptor to include the authkey dynamically
appConfig.interceptors.request.use(
  (config) => {
    const authkey = localStorage.getItem("_authkey") ? localStorage.getItem("_authkey") :  "6808842ce47ce24a786eee68";
    if (authkey) {
      config.headers["authkey"] = authkey;
    }
    config.headers["timezone"] = timezone;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default appConfig;
